import {
  PERSONAL_PROJECT_SCOPE,
  type NormalizedProjectListParams,
  type ProjectListParams,
  type ProjectListScope,
} from "./types";

export const DEFAULT_PROJECT_LIST_PARAMS: NormalizedProjectListParams = {
  skip: 0,
  limit: 100,
  includeShared: true,
  includeDeleted: false,
};

export const normalizeProjectListParams = (
  params: ProjectListParams = {},
): NormalizedProjectListParams => ({
  skip: params.skip ?? DEFAULT_PROJECT_LIST_PARAMS.skip,
  limit: params.limit ?? DEFAULT_PROJECT_LIST_PARAMS.limit,
  includeShared:
    params.includeShared ?? DEFAULT_PROJECT_LIST_PARAMS.includeShared,
  includeDeleted:
    params.includeDeleted ?? DEFAULT_PROJECT_LIST_PARAMS.includeDeleted,
});

export const projectQueryKeys = {
  all: ["projects"] as const,
  lists: () => [...projectQueryKeys.all, "list"] as const,
  listScope: (scope: ProjectListScope) =>
    [
      ...projectQueryKeys.lists(),
      scope.principalId,
      scope.organizationId || PERSONAL_PROJECT_SCOPE,
    ] as const,
  list: (
    scope: ProjectListScope,
    params: ProjectListParams = {},
  ) =>
    [
      ...projectQueryKeys.listScope(scope),
      normalizeProjectListParams(params),
    ] as const,
};
